export default __webpack_public_path__ + "static/media/tanhao.a06acb2c.svg";